import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { daDK, deDE, esES, enUS, nbNO, nlNL } from '@mui/material/locale';
import { LicenseInfo as LicenseInfoV6 } from '@mui/x-license-pro';
import { LicenseInfo as LicenseInfoV8 } from '@mui/x-license';
import { exhaustiveCheck } from '@famly/stat_ts-utils_exhaustive-check';
import { ThemeProvider } from '@famly/mf_theme';
/**
 * The public key for mui-x pro. This key is meant to be public.
 * See https://mui.com/x/introduction/licensing/#security for more info.
 *
 * We set the license for both v6 (@mui/x-license-pro) and v8 (@mui/x-license) packages
 * to support both @mui/x-date-pickers-pro (v6) and @mui/x-data-grid-pro (v8).
 */
const MUI_X_LICENSE_KEY = '9ea59b6b803cf7fa2c7211c0a5d96614Tz0xMjk3ODAsRT0xODEyMTUzNTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=';
LicenseInfoV6.setLicenseKey(MUI_X_LICENSE_KEY);
LicenseInfoV8.setLicenseKey(MUI_X_LICENSE_KEY);
export const useModernFamlyContext = () => {
    return React.use(ModernFamlyContext);
};
export const ModernFamlyContext = React.createContext({
    isMobileApp: false,
    locale: 'enUS',
    isDisplayingDatePicker: false,
    setIsDisplayingDatePicker: () => {
        console.warn('ModernFamlyContext not initialized');
    },
});
const languageToLocalization = (supportedLanguage) => {
    switch (supportedLanguage) {
        case 'daDK': {
            return { core: daDK };
        }
        case 'deCH':
        case 'deDE': {
            return { core: deDE };
        }
        case 'esUS':
        case 'esES': {
            return { core: esES };
        }
        case 'enGB':
        case 'enUS': {
            return { core: enUS };
        }
        case 'nbNO': {
            return { core: nbNO };
        }
        case 'nlNL': {
            return { core: nlNL };
        }
        default:
            exhaustiveCheck(supportedLanguage);
            return { core: enUS };
    }
};
export const ModernFamlyProvider = (props) => {
    var _a;
    const locale = (_a = props.language) !== null && _a !== void 0 ? _a : 'enUS';
    const localizations = languageToLocalization(locale);
    const [isDisplayingDatePicker, setIsDisplayingDatePicker] = React.useState(false);
    return (_jsx(ThemeProvider, { theme: props.theme, localization: localizations.core, LinkBehavior: props.LinkBehavior, children: _jsx(ModernFamlyContext, { value: { isMobileApp: props.isMobileApp, locale, isDisplayingDatePicker, setIsDisplayingDatePicker }, children: props.children }) }));
};
